import { render, staticRenderFns } from "./select_option.vue?vue&type=template&id=2bd382f0&scoped=true"
import script from "./select_option.vue?vue&type=script&lang=js"
export * from "./select_option.vue?vue&type=script&lang=js"
import style0 from "./select_option.vue?vue&type=style&index=0&id=2bd382f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd382f0",
  null
  
)

export default component.exports